import './index.scss';
import React, { Component } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import BotTagManagerField from '../Field';

export class BotTagManagerPopover extends Component {
  state = {
    isOpen: false,
  };

  toggle = (isOpen) => {
    this.setState({ isOpen });
  };

  render() {
    return (
      <Dropdown
        className="BotTagManagerPopover gecko-dropdown"
        show={this.state.isOpen}
        onToggle={this.toggle}
      >
        <Dropdown.Toggle as="span" className="BotTagManagerPopover-toggle">
          <span>{this.props.children}</span>
        </Dropdown.Toggle>

        <Dropdown.Menu className="BotTagManagerPopover-dropdown gecko-dropdown-menu dropdown-menu-left">
          {this.state.isOpen ? (
            <BotTagManagerField
              config={{ isOpen: true, autoFocus: true }}
              item={this.props.item}
              onChange={this.props.onChange}
              controlled={this.props.controlled}
            />
          ) : null}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

BotTagManagerPopover.defaultProps = {
  item: {},
  onChange: () => {},
  controller: false,
};

export default BotTagManagerPopover;
